import { createRequest } from '@/network/request'
let request = createRequest();
export function lottery(params:any) {
    return request.post('/faw/lottery',params)
}